import { render, staticRenderFns } from "./NotificationAreaClearMobile.vue?vue&type=template&id=78ec6e80&scoped=true&"
import script from "./NotificationAreaClearMobile.vue?vue&type=script&lang=js&"
export * from "./NotificationAreaClearMobile.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAreaClearMobile.vue?vue&type=style&index=0&id=78ec6e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec6e80",
  null
  
)

export default component.exports